import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeroSearchForm from './HeroSearchForm';

export default function HeroSection2() {
    return (
        <>
            <section className='hero-section hero-section-two' id='home2'>
                <Container>
                    <Row>
                        <Col lg={10} xxl={8}>
                            <div className="hero-section-main-content">
                                <div className="hero-section-content w-100 position-relative">
                                    <Row className=''>
                                        <Col lg={12} xl={10}>
                                            <span className='hero-badge shadow-sm mb-3'>A Vision for Your Life</span>
                                            <h1 className='hero-title display-3 fw-bold mb-0'>Find Your Ideal <span className='text-primary'>Real Estate</span> Now</h1>
                                            <p className='fw-medium text-dark mt-4 pt-1 me-xl-4 mb-50'>Explore premium properties tailored to your needs, from stunning homes to lucrative investments. Start your journey with us and unlock the key to your dream real estate.</p>
                                        </Col>
                                    </Row>
                                    <Row className=''>
                                        <Col xl={12}>
                                            <ul className="nav nav-tabs ms-3 hero-tab-filter" id="myTab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link active" id="buy-tab" data-bs-toggle="tab" data-bs-target="#buy-tab-pane"
                                                        type="button" role="tab" aria-controls="buy-tab-pane" aria-selected="true">Buy</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="sell-tab" data-bs-toggle="tab" data-bs-target="#sell-tab-pane"
                                                        type="button" role="tab" aria-controls="sell-tab-pane" aria-selected="false">Sell</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className="nav-link" id="rent-tab" data-bs-toggle="tab" data-bs-target="#rent-tab-pane"
                                                        type="button" role="tab" aria-controls="rent-tab-pane" aria-selected="false">Rent</button>
                                                </li>
                                            </ul>
                                            <div className="tab-content hero-tab-content" id="myTabContent">
                                                <div className="tab-pane fade show active" id="buy-tab-pane" role="tabpanel" aria-labelledby="buy-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                                <div className="tab-pane fade" id="sell-tab-pane" role="tabpanel" aria-labelledby="sell-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                                <div className="tab-pane fade" id="rent-tab-pane" role="tabpanel" aria-labelledby="rent-tab" tabIndex="0">
                                                    <HeroSearchForm />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
